import type { TextMessagesConnector } from "@/types/connectors.ts";

/** The connector's name wherever it is shown. */
export const TEXT_MESSAGES_NAME = "Text Messages";

type NeedsAttention = NonNullable<TextMessagesConnector["needsAttention"]>;

/** What the needs-attention notice says, and the text that lifts it. */
export type TextMessagesNotice = {
  message: string;
  /** Prefilled in the person's text to Okthx, or empty when any text will do. */
  smsBody: string;
};

/**
 * The notice for why Okthx's texts are refused. A reply-limit block lifts on
 * any text from the person; an opt-out lifts only on START.
 */
export function textMessagesNotice(reason: NeedsAttention): TextMessagesNotice {
  switch (reason) {
    case "replyLimit":
      return {
        message: "We can't text you yet. Send us a text and we'll be able to text you.",
        smsBody: "",
      };
    case "optedOut":
      return {
        message: "You asked us to stop texting you. Text START to turn texts back on.",
        smsBody: "START",
      };
  }
}

/**
 * An `sms:` link that opens Messages with a new text to `number`, its body
 * prefilled when given. iOS reads the body after `&`; it is percent-encoded so
 * nothing in it can change what the link does.
 */
export function smsComposeUrl(number: string, body = ""): string {
  const to = number.replace(/[^\d+]/g, "");
  return body ? `sms:${to}&body=${encodeURIComponent(body)}` : `sms:${to}`;
}
